export default __webpack_public_path__ + "static/media/program-page.0bcbb8f4.png";